module.exports = __webpack_public_path__ + "media/images/brand/new_stuff_letter/cowgor_x1-ea1da61c3c95360608e02d1513434273.jpg";